// File: client/src/variants/power/rulebook.js
// Canonical rulebook for Power Chess.

const rulebook = {
  overview:
    'Chess meets RPG. Every piece TYPE has a special ability with a cooldown. Activate abilities from the ability bar to gain a movement edge, protect a piece, or take a double move.',
  objective:
    'Checkmate the opponent’s king. Standard chess rules, supercharged by abilities.',
  setup:
    'Standard starting position. All abilities start ready (no cooldown). White moves first.',
  turnFlow: [
    'Optionally activate ONE ability from your ability bar.',
    'Movement abilities (Sprint, Leap) are ARMED — make the matching piece’s move to use it.',
    'Effect abilities (Fortify, Cleanse, Blitz, Royal Command) apply immediately.',
    'Make your move. Blitz lets you move a second time this turn.',
    'Using an ability puts it on cooldown, counted in YOUR turns.',
  ],
  mechanics: [
    {
      title: 'Abilities',
      items: [
        '🏃 Pawn — Sprint (CD 3): a pawn moves two squares forward (both empty) from any rank.',
        '🦘 Knight — Leap (CD 3): the knight jumps to any square within distance 2, ignoring blockers.',
        '➕ Bishop — Cleanse (CD 4): the bishop cannot be captured until your next turn.',
        '🛡️ Rook — Fortify (CD 4): the rook cannot be captured until your next turn.',
        '⚡ Queen — Blitz (CD 5): make two moves this turn (not the same piece twice).',
        '👑 King — Royal Command (CD 6): reset the cooldowns of all your abilities.',
      ],
    },
    {
      title: 'Cooldowns',
      body: 'Each ability, once used, is unavailable for a number of YOUR turns (shown on the ability bar). The bar shows “Ready” or the remaining cooldown for each ability.',
    },
  ],
  winConditions: [
    'Win by checkmate.',
    'Win if the opponent resigns or runs out of time.',
    'Stalemate is a draw.',
  ],
  tips: [
    'Blitz + a threat can be devastating: attack, then follow up before the opponent replies.',
    'Fortify a rook to anchor a defence the opponent literally cannot capture this turn.',
    'Royal Command refills everything — save it for a decisive combo of abilities next turn.',
  ],
  knownInteractions: [
    'Rule decision: the Bishop’s brief ability was “Heal / remove a debuff”. Since there is no debuff system, it is reinterpreted as CLEANSE — one turn of capture-immunity for the bishop (a defensive “heal”).',
    'Rule decision: the Knight’s “Leap / ignore occupied path” is reinterpreted as reaching ANY square within distance 2 (knights already leap), ignoring blockers.',
    'Rule decision: Fortify/Cleanse protect the FIRST rook/bishop found for that side, and the immunity lasts until the owner’s next move. Protected captures are removed from the opponent’s legal moves.',
    'Rule decision: Blitz keeps the turn open for exactly one extra move; checkmate during the combo ends the game immediately (same as UNO number cards).',
    'Rule decision: cooldowns tick down on the owner’s own turns; Royal Command resets them to Ready.',
    'AI: the computer plays standard chess and does NOT activate abilities (it plays the base game). Its pieces are still subject to your abilities (e.g. it cannot capture your Fortified rook). Documented limitation — a future variant AI hook could let the AI use abilities.',
  ],
};

export default rulebook;
